import { createFileRoute } from "@tanstack/react-router";
import { VariablesScreen } from "./-settings/VariablesScreen";

export const Route = createFileRoute("/$workspace/$project/settings/variables")({
  staticData: { title: "Variables" },
  component: VariablesScreen,
});
